import { Component, OnInit } from '@angular/core';
import { AuthorService } from 'src/app/services/author.service';
import { FileService } from 'src/app/services/file.service';
import { AlertController, ModalController } from '@ionic/angular';
import { UnsavedSceneService } from 'src/app/services/unsaved-scene.service';
import { VrEventService } from 'src/app/services/vr-event.service';
import { ApiVrEventService } from 'src/app/api-services/vr-event.api.service';
import { UnfocusElementService } from 'src/app/services/unfocus-element.service';
import { Scene } from 'src/app/models/Scene';
import { AssetInScene } from 'src/app/models/AssetInScene';
import { AddEventsModalPage } from '../add-events-modal/add-events-modal.page';
import { ValidationService } from 'src/app/services/validation.service';
import { MessagesService } from 'src/app/services/messages.service';
import { FileSizeService } from 'src/app/services/file-size.service';
import { SceneBackgroundModalPage } from '../scene-background-modal/scene-background-modal.page';

@Component({
  selector: 'app-scene-settings-modal',
  templateUrl: './scene-settings-modal.page.html',
  styleUrls: ['./scene-settings-modal.page.scss'],
})
export class SceneSettingsModalPage implements OnInit {

  public scene: Scene;
  public isModalOpen: boolean = false;
  public backgroundRotationInterval = null;
  public sceneYRot: string = '0';

  constructor(
    public authorService: AuthorService,
    public fileService: FileService,
    public alertController: AlertController,
    public modalController: ModalController,
    public unsavedSceneService: UnsavedSceneService,
    public VrEventService: VrEventService,
    public VrEventAPIService: ApiVrEventService,
    public unfocusService: UnfocusElementService,
    public validationService: ValidationService,
    public messagesService: MessagesService,
    public fileSizeService: FileSizeService
  ) { }

  ngOnInit() {
    if(this.scene.sceneBackgroundFileType == 'Video'){
      var sceneSettingsModal = document.getElementById('scene-settings-modal');
      sceneSettingsModal.classList.add('video');
    }    
  }

  toggleModalTransparency(event) {
    var sceneSettingsModal = document.getElementById('scene-settings-modal');

    sceneSettingsModal.style.opacity = Number(sceneSettingsModal.style.opacity) != 0.3 ? '0.3' : '1';
  }
  
  saveScene(event) {
    this.unfocusService.unfocus(event);
    this.scene.name = this.validationService.removeHtmlTags(this.scene.name);
    if (!this.validationService.isEmptyOrNull(this.scene.name)) {
      this.authorService.scenes.forEach(x => {
        if (x.sceneId == this.scene.sceneId) {
          x.name = this.validationService.removeHtmlTags(this.scene.name);
          x.description = this.scene.description;
          this.authorService.updateSceneInDb(x);
          this.messagesService.updatedSuccessfully('Scene');
        }
      });
    } else {
      this.alertForSceneName();
    }
  }

  async alertForSceneName() {
    const alert = await this.alertController.create({
      header: 'Scene Name Required',
      buttons: [{
        text: 'Ok',
      }
      ]
    });
    await alert.present();
  }

  /* changeSceneInitialPosition(){
    let cameraCursor = document.querySelector('#camera-cursor');
    this.authorService.movingSceneInitialPosition = true;
    this.authorService.disableAssetClick();
    this.authorService.moveCameraTo(Number(this.authorService.currentScene.xRot), Number(this.authorService.currentScene.yRot));
    cameraCursor.setAttribute('color', 'red');
    this.closeModal();
  } */

  initBackgroundRotationInterval(valueToApply: number) {
    this.backgroundRotationInterval = setInterval(() => {
      this.changeBackgroundRotation(valueToApply);
    }, 10);
  }

  clearBackgroundRotationInterval() {
    if (this.backgroundRotationInterval) {
      clearInterval(this.backgroundRotationInterval);
      this.backgroundRotationInterval = null;
    }
  }

  changeBackgroundRotation(value: number) {
    let y: number = Number(this.sceneYRot);
    y += value;

    this.sceneYRot = String(y);
  }

  updateBackgroundRotation(){
    let y: number = 0;

    y = Number(this.sceneYRot);
    
    if(y > 360) y = y - 360;
    if(y < 0) y = y + 360;

    this.sceneYRot = String(y);
    y = 360 - y;
    
    this.authorService.currentScene.yRot = String(y);

    this.authorService.moveCameraTo(0, y); // Move the camera to initial position    
  }

  async changeBackgroundFile(event) {
    if (!event.target.files[0].type) {
      return false;
    }
    var sceneId: number = this.authorService.currentScene.sceneId
    var fileType: string = event.target.files[0].type;
    if (fileType.startsWith('image') && (fileType.endsWith('/png') || fileType.endsWith('/gif') || fileType.endsWith('/jpeg'))) {
      if (this.authorService.currentScene.sceneBackgroundSrc != null) {
        this.authorService.skyId = "#pano-blank";

        this.fileService.replaceSceneBackgroundFile(event, '5a0ffb5a-475d-4307-bf05-237f82a9302d').then(async (srcResult) => {
          await this.messagesService.presentLoadingWindow('Loading new background...');
          this.authorService.currentScene.sceneBackgroundSrc = srcResult;
          this.authorService.currentScene.sceneBackgroundColour = '#FFFFFF';
          this.authorService.currentScene.sceneBackgroundFileType = 'Image';
          this.authorService.currentScene.sceneBackgroundFileSize = await this.fileSizeService.getFileSize(this.authorService.currentScene.sceneBackgroundSrc);
          await this.messagesService.loadingWindow.dismiss();
          this.authorService.launchScene(sceneId);
          
          var sceneSettingsModal = document.getElementById('scene-settings-modal');
          if(sceneSettingsModal.classList.contains('video')){
            sceneSettingsModal.classList.remove('video');
          }
        });
      }
    }
    else if (fileType.startsWith('video') && (fileType.endsWith('/quicktime') || fileType.endsWith('/mp4'))) {
      if (this.authorService.currentScene.sceneBackgroundSrc != null) {
        this.authorService.skyId = '#pano-blank';

        const alert = await this.alertController.create({
          header: 'Upload Video Background',
          message: '"Compress Video" option is recommended for quicker loading times, but may affect the video resolution.',
          cssClass: 'leave-alert',
          buttons: [{
            text: 'Compress Video & Upload',
            cssClass: 'leave-button',
            handler: () => {
              this.fileService.replaceSceneBackgroundFile(event, '5a0ffb5a-475d-4307-bf05-237f82a9302d', true).then((srcResult) => {
                let scene = this.authorService.currentScene;
                scene.uploadStatus = 'uploading';
                scene.sceneBackgroundSrc = this.fileService.videoAssetUploadingPlaceholder;
                scene.sceneBackgroundColour = '#FFFFFF';
                scene.sceneBackgroundFileType = 'Video';
                this.authorService.launchScene(sceneId);
                this.fileService.addVideoToCheckUploadStatus('scene', sceneId, scene, srcResult);
                this.fileService.initialiseVideoUploadStatusCheck();

                var sceneSettingsModal = document.getElementById('scene-settings-modal');
                if(!sceneSettingsModal.classList.contains('video')){
                  sceneSettingsModal.classList.add('video');
                }
              });
            }
          }, {
            text: 'Upload Only',
            cssClass: 'leave-button',
            handler: () => {
              this.fileService.replaceSceneBackgroundFile(event, '5a0ffb5a-475d-4307-bf05-237f82a9302d').then(async (srcResult) => {
                this.authorService.currentScene.uploadStatus = 'complete';
                this.authorService.currentScene.sceneBackgroundSrc = srcResult;
                this.authorService.currentScene.sceneBackgroundColour = '#FFFFFF';
                this.authorService.currentScene.sceneBackgroundFileType = 'Video';
                this.authorService.currentScene.sceneBackgroundFileSize = await this.fileSizeService.getFileSize(this.authorService.currentScene.sceneBackgroundSrc);
                this.authorService.launchScene(sceneId);

                var sceneSettingsModal = document.getElementById('scene-settings-modal');
                if(!sceneSettingsModal.classList.contains('video')){
                  sceneSettingsModal.classList.add('video');
                }
              });
            }
          }
          ]
        });
        await alert.present();
      }
    }
    else {
      this.alertIncompatibleFile();
    }
  }

  removeSceneBackground(scene: Scene) {
    scene.sceneBackgroundSrc = '';
    scene.sceneBackgroundFileType = '';
    scene.sceneBackgroundFileSize = 0;
    this.authorService.skyId = null;

    var sceneSettingsModal = document.getElementById('scene-settings-modal');
    if(sceneSettingsModal.classList.contains('video')){
      sceneSettingsModal.classList.remove('video');
    }

    this.authorService.launchScene(scene.sceneId);
  }

  async alertIncompatibleFile() {
    const alert = await this.alertController.create({
      header: 'Incompatible file uploaded.',
      buttons: [{
        text: 'Ok',
      }
      ]
    });
    await alert.present();
  }

  async displayBackgroundModal(event) {
    this.unfocusService.unfocus(event);

    if (this.isModalOpen === true) return;
    this.isModalOpen = true;

    const modal = await this.modalController.create({
      component: SceneBackgroundModalPage,
      id: 'add-scene-background-modal',
    });

    modal.onDidDismiss().then(async result => {
      this.isModalOpen = false;

      if (result.data && result.data.backgroundSrc && result.data.assetType) {
        await this.messagesService.presentLoadingWindow('Loading new background...');
        this.authorService.currentScene.sceneBackgroundFileType = result.data.assetType;
        this.authorService.currentScene.sceneBackgroundSrc = result.data.backgroundSrc;

        if (!result.data.compressing) {
          this.authorService.currentScene.sceneBackgroundFileSize = await this.fileSizeService.getFileSize(result.data.backgroundSrc);
        }

        await this.messagesService.loadingWindow.dismiss();
        this.authorService.launchScene(this.authorService.currentScene.sceneId);

        var sceneSettingsModal = document.getElementById('scene-settings-modal');
        if(!sceneSettingsModal.classList.contains('video')){
          sceneSettingsModal.classList.add('video');
        }
      }
    });

    modal.present().then(() => {
    });
  }

  async openAddSceneEventModal(event, currentScene) {
    this.unfocusService.unfocus(event);

    if (this.isModalOpen === true) return;
    this.isModalOpen = true;

    this.authorService.stopAutoSave();

    var existingAssets: AssetInScene[] = this.authorService.assetsInScene.filter(a => a.sceneAssetRelation.sceneId == currentScene.sceneId);
    this.VrEventService.setUpSceneEvent(currentScene, existingAssets, this.authorService.scenes.filter(c => c.active == true));

    const modal = await this.modalController.create({
      component: AddEventsModalPage,
      id: 'add-scene-events-modal',
    });

    modal.onDidDismiss().then(result => {
      currentScene.events.forEach(event => {
        if (event.vrEventId > 0) {
          this.VrEventAPIService.updateSceneEvent(event.vrEventId, event).subscribe();
        }
      });
      this.isModalOpen = false;
      this.authorService.startAutosave(90000);
    });

    modal.present().then(() => {
      // var sceneSettingsModal = document.querySelector('#scene-settings-modal');
      // var sceneEventsModal = document.querySelector('#add-scene-events-modal');
      // var zIndex: number = +sceneSettingsModal.style.zIndex;
      // sceneEventsModal.style.zIndex = (zIndex + 10).toString();
    });
  }

  async confirmRemoveSceneBackground(event, currentScene) {
    this.unfocusService.unfocus(event);

    const alert = await this.alertController.create({
      header: 'Please confirm',
      message: "Are you sure you want to remove the scene background?",
      buttons: [{
        text: 'Cancel',
      }, {
        text: 'Delete',
        handler: () => {
          this.removeSceneBackground(currentScene);
        }
      }]
    });
    await alert.present();
  }

  clickButton(buttonID) {
    document.getElementById(buttonID).click();
  }

  setIsSaved(isSaved) {
    this.unsavedSceneService.setHasSceneBeenSaved(isSaved);
  }

  closeModal() {
    this.modalController.dismiss();
  }

  showSceneColourPicker() {
    var colourPicker = document.querySelector('#scene-background-colour-picker');
    if (colourPicker) colourPicker.click();
  }

  setSceneYRotValue(){
    this.sceneYRot = String(360 - Number(this.authorService.currentScene.yRot));
  }
}
